'use client';

import { useEffect, useState } from 'react';

export function useSearchPanel() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const openPanel = () => setIsOpen(true);
    function handleKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === '/') {
        e.preventDefault();
        setIsOpen((prev) => !prev);
      }
    }
    window.addEventListener('keydown', handleKey);
    window.addEventListener('kontora:open-search', openPanel);
    return () => {
      window.removeEventListener('keydown', handleKey);
      window.removeEventListener('kontora:open-search', openPanel);
    };
  }, []);

  return { isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) };
}
